export const dirtyCostEstimate = (project, designId) => {
  const dirtyEstimates = project.designs[designId].costEstimates.map(quote => {return {...quote, isDirty: true}});
  return dirtyEstimates;
}
